export const getUploadSpaceError = (limits, files) => {
  if (!limits) return "У рабочего пространства отсутствует тариф";
  const sizeLimit = limits.find(
    (value) => value.attributeCode === "AVAILABLE_SPACE_MB"
  );
  if (!sizeLimit || sizeLimit.maxValue === -1) return null;

  const availableMb = sizeLimit.maxValue - sizeLimit.usedValue;
  const totalBytes = files.reduce((sum, f) => sum + f.size, 0);
  if (availableMb * 1024 * 1024 < totalBytes) {
    return `Недостаточно места в соответствии с вашим текущим тарифом. Доступно: ${availableMb.toFixed(
      2
    )}МБ`;
  }
  return null;
};
